import { Layout, MaintenanceInfo as MaintenanceInfoComponent } from "components"
export const MaintenanceInfo = () => {
 return (
  <Layout>
   <MaintenanceInfoComponent />
  </Layout>
 )
}
